import IconButtonWrapper from './IconButtonWrapper';

export default IconButtonWrapper;
